module.exports = __webpack_public_path__ + "img/training.jpg";